import type * as ecModels from '../../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<
  TTypeParams extends ecModels.TypeParams = ecModels.TypeParams,
> {
  /**
   * IDs of the entities that make up the current list
   *
   * The entities themselves exist in the cache plugin
   */
  ids: readonly ecModels.EntityId[]
  /**
   * Number of entities that match the applied params
   */
  matchedCount?: number
  /**
   * Indicates the current list parameters are being edited
   */
  isEditingParams: boolean
  /**
   * Indicates the current list is in the process of being loaded
   */
  isLoading: boolean
  /**
   * Error encountered when trying to retrieve the current list
   */
  error?: Error
}
export namespace State {
  export const INITIAL: State = {
    ids: [],
    isEditingParams: false,
    isLoading: false,
  }
}
